<template>
  <a-modal
      title="订单详情"
      :dialogStyle="{ minWidth: '1200px' }"
      :bodyStyle="{ maxHeight: '800px', overflow: 'auto' }"
      :visible="visible"
      @cancel="$emit('update:visible', false)"
  >
    <template #footer>
      <a-button @click="$emit('update:visible', false)">取消</a-button>
    </template>
    <a-table
        ref="table"
        size="default"
        :columns="columns"
        :dataSource="goodsList"
        :pagination="false"
    >
      <span slot="specs" slot-scope="text, record">
        {{ `${text}${record.specsUnit}` }}
      </span>
      <span slot="priceStr" slot-scope="text, record">
        {{ record.discountPrice / 100 || record.unitPrice / 100 }}
      </span>
    </a-table>
  </a-modal>
</template>
<script>
import {loadPlatformOrderDetail, loadPlatformOrderDetail2} from "@/api/account";
import getOrderDescMixin from "@/mixins/getOrderDescMixin";

export default {
  mixins: [getOrderDescMixin],
  props: {
    visible: {
      type: Boolean,
      require: true
    },
    orderId: {
      type: String,
      require: true
    }
  },
  data () {
    return {
      columns: [
        {
          title: '商品名称',
          dataIndex: 'itemName'
        },
        {
          title: '规格',
          dataIndex: 'specs',
          scopedSlots: { customRender: 'specs' }
        },
        {
          title: '数量',
          dataIndex: 'quantity'
        },
        {
          title: '单价',
          dataIndex: 'priceStr',
          scopedSlots: { customRender: 'priceStr' }
        },
        {
          title: '小计',
          customRender: (text, record) => `${((record.discountPrice || record.unitPrice) * record.quantity).toFixed(2) / 100}`
        },
        {
          title: '总积分',
          dataIndex: 'itemPoint'
        }
      ],
      orderInfo: null
    }
  },
  watch: {
    visible (val) {
      if (val) {
        loadPlatformOrderDetail2(this.orderId).then(res => {
          this.orderInfo = res.data
        })
      } else {
        this.orderInfo = null
      }
    }
  },
  computed: {
    goodsList () {
      if (!this.orderInfo) return []
      return this.orderInfo
    }
  }
}
</script>
